module.exports = __webpack_public_path__ + "img/logo-faces.bbadca09.png";